import { NgModule } from '@angular/core';
import { DatePipe } from '@angular/common';
import { AccessibilityHasGuidelineIdPipe } from '@client/app/filters/accessibility/has-guideline-id.pipe';
import { AccessibilityHasGuidelinePipe } from '@client/app/filters/accessibility/has-guideline.pipe';
import { AccessibilityCloseCaptionPipe } from '@client/app/filters/accessibility/close-caption.pipe';
import { IsDefinedPipe } from '@client/app/filters/common/is-defined.pipe';
import { IsFunctionPipe } from '@client/app/filters/common/is-function.pipe';
import { IsNumberPipe } from '@client/app/filters/common/is-number.pipe';
import { SearchFieldPipe } from '@client/app/filters/common/search-field.pipe';
import { IsStatsSampleDataPipe } from '@client/app/filters/is-stats-dumy-data.pipe';
import { UptimeIncidientTimePipe } from '@client/app/filters/uptime-incidient-time.pipe';
import { MonSetMyTimezonePipe } from '@client/app/filters/set-to-my-timezone.pipe';
import { MonCharacterLimitPipe } from '@client/app/filters/character-limit.pipe';
import { HasDomainAccessPipe } from '@client/app/filters/has-domain-access.pipe';
import { FullUrlPipe } from '@client/app/filters/full-url.pipe';
import { TranslateWithPluralPipe } from '@client/app/filters/translate-with-plural.pipe';
import { MonNumberPipe } from '@client/app/filters/mon-number.pipe';
import { TranslateReadabilityPipe } from '@client/app/filters/translate-readability.pipe';
import { DomainActiveFeaturePipe } from '@client/app/filters/domain-active-feature.pipe';
import { E2eAttributeEncodingPipe } from '@client/app/filters/encode-uri.pipe';
import { UnderscorelessPipe } from '@client/app/filters/underscoreless.pipe';
import { MonIconsPipe } from '@client/app/filters/mon-icons.pipe';
import { TranslateSeoIssuePipe } from '@client/app/filters/translate-seo-issue.pipe';
import { WcagClassPipe } from '@client/app/filters/wcag-class.pipe';
import { HasAccessPipe } from '@client/app/filters/has-access.pipe';
import { RolePipe } from '@client/app/filters/role.pipe';
import { ActiveFeaturePipe } from '@monsido/core/pipes/active-feature/active-feature.pipe';
import { InverseColorCodePipe } from '@client/app/filters/inverse-color-code.pipe';
import { CapitalizePipe } from '@client/app/filters/capitalize.pipe';
import { EscapeHtmlPipe } from '@client/app/filters/escape-html.pipe';
import { EscapeRegExpPipe } from '@client/app/filters/escape-reg-exp.pipe';
import { GenerateUrlParamsPipe } from '@client/app/filters/generate-url-params.pipe';
import { MonRemoveWhiteSpacePipe } from '@client/app/filters/mon-remove-white-space.pipe';
import { ReturnHostnamePipe } from '@client/app/filters/return-hostname.pipe';
import { UserDatePipe } from '@client/app/filters/user-date.pipe';
import { TranslateLanguagePipe } from '@client/app/filters/translate-language.pipe';
import { HasDemoAccessPipe } from '@client/app/filters/has-demo-access.pipe';
import { IsUsingDemoDataPipe } from '@client/app/filters/is-using-demo-data.pipe';
import { PageFixSettingsPipe } from '@client/app/filters/page-fix-settings.pipe';
import { FrequencyTranslationPipe } from '@client/app/modules/page-performance/pipes/frequency-translation.pipe';
import { SearchNativePipe } from '@client/app/filters/common/search-native.pipe';

@NgModule({
    imports: [ActiveFeaturePipe],
    exports: [
        AccessibilityHasGuidelineIdPipe,
        AccessibilityHasGuidelinePipe,
        AccessibilityCloseCaptionPipe,
        IsDefinedPipe,
        IsFunctionPipe,
        IsNumberPipe,
        SearchFieldPipe,
        IsStatsSampleDataPipe,
        UptimeIncidientTimePipe,
        MonSetMyTimezonePipe,
        MonCharacterLimitPipe,
        HasDomainAccessPipe,
        FullUrlPipe,
        TranslateWithPluralPipe,
        MonNumberPipe,
        TranslateReadabilityPipe,
        DomainActiveFeaturePipe,
        E2eAttributeEncodingPipe,
        UnderscorelessPipe,
        MonIconsPipe,
        TranslateSeoIssuePipe,
        WcagClassPipe,
        HasAccessPipe,
        RolePipe,
        InverseColorCodePipe,
        CapitalizePipe,
        EscapeHtmlPipe,
        EscapeRegExpPipe,
        GenerateUrlParamsPipe,
        MonRemoveWhiteSpacePipe,
        ReturnHostnamePipe,
        UserDatePipe,
        TranslateLanguagePipe,
        HasDemoAccessPipe,
        IsUsingDemoDataPipe,
        PageFixSettingsPipe,
        FrequencyTranslationPipe,
        SearchNativePipe,
    ],
    declarations: [
        AccessibilityHasGuidelineIdPipe,
        AccessibilityHasGuidelinePipe,
        AccessibilityCloseCaptionPipe,
        IsDefinedPipe,
        IsFunctionPipe,
        IsNumberPipe,
        SearchFieldPipe,
        IsStatsSampleDataPipe,
        UptimeIncidientTimePipe,
        MonSetMyTimezonePipe,
        MonCharacterLimitPipe,
        HasDomainAccessPipe,
        FullUrlPipe,
        TranslateWithPluralPipe,
        MonNumberPipe,
        TranslateReadabilityPipe,
        DomainActiveFeaturePipe,
        E2eAttributeEncodingPipe,
        UnderscorelessPipe,
        MonIconsPipe,
        TranslateSeoIssuePipe,
        WcagClassPipe,
        HasAccessPipe,
        RolePipe,
        InverseColorCodePipe,
        CapitalizePipe,
        EscapeHtmlPipe,
        EscapeRegExpPipe,
        GenerateUrlParamsPipe,
        MonRemoveWhiteSpacePipe,
        ReturnHostnamePipe,
        UserDatePipe,
        TranslateLanguagePipe,
        HasDemoAccessPipe,
        IsUsingDemoDataPipe,
        PageFixSettingsPipe,
        FrequencyTranslationPipe,
        SearchNativePipe,
    ],
    providers: [
        DatePipe,
        AccessibilityHasGuidelineIdPipe,
        AccessibilityHasGuidelinePipe,
        AccessibilityCloseCaptionPipe,
        IsDefinedPipe,
        IsFunctionPipe,
        IsNumberPipe,
        SearchFieldPipe,
        IsStatsSampleDataPipe,
        UptimeIncidientTimePipe,
        MonSetMyTimezonePipe,
        MonCharacterLimitPipe,
        HasDomainAccessPipe,
        FullUrlPipe,
        TranslateWithPluralPipe,
        MonNumberPipe,
        TranslateReadabilityPipe,
        DomainActiveFeaturePipe,
        E2eAttributeEncodingPipe,
        UnderscorelessPipe,
        MonIconsPipe,
        TranslateSeoIssuePipe,
        WcagClassPipe,
        HasAccessPipe,
        RolePipe,
        InverseColorCodePipe,
        CapitalizePipe,
        EscapeHtmlPipe,
        EscapeRegExpPipe,
        GenerateUrlParamsPipe,
        MonRemoveWhiteSpacePipe,
        ReturnHostnamePipe,
        UserDatePipe,
        DatePipe,
        TranslateLanguagePipe,
        HasDemoAccessPipe,
        IsUsingDemoDataPipe,
        PageFixSettingsPipe,
        FrequencyTranslationPipe,
        SearchNativePipe,
    ],
})
export class UpgradePipeModule {}

